<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.setup.program.subject.core_subjects.core_subject')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.setup.program.subject.core_subjects.core_subject'
            ),
            active: true
          }
        ]"
      />
    </div>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">
              {{
                $t(
                  'school.academic.setup.program.subject.core_subjects.add_new'
                )
              }}
            </ts-button>
            <ts-input
              v-model="search"
              :placeholder="
                $t('school.academic.setup.program.subject.core_subjects.search')
              "
              style="width: 300px;"
            />
          </div>
        </ts-card-wrapper>
        <div class="overflow-auto">
          <ts-table :columns="columns" :records="resources" :loading="loading">
            <template v-slot="{ record }">
              <td class="ts-whitespace-no-wrap">
                {{ record.subject_name_foreign }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.subject_name_native }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.ministry_name_foreign }}
              </td>
              <td class="ts-whitespace-no-wrap">
                {{ record.ministry_name_native }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.total_hour }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.credit_theory }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.credit_practice }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                {{ record.credit_intern }}
              </td>
              <td class="ts-whitespace-no-wrap text-center">
                <a
                  href="#"
                  v-tooltip="
                    $t(
                      'school.academic.setup.program.subject.core_subjects.assessment_components'
                    )
                  "
                  class="text-info mr-2"
                  @click.prevent="showComponent(record)"
                >
                  <i class="fas fa-align-justify"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="
                    $t(
                      'school.academic.setup.program.subject.core_subjects.edit'
                    )
                  "
                  class="text-primary mr-2"
                  @click.prevent="edit(record)"
                >
                  <i class="fas fa-edit"></i>
                </a>
                <a
                  href="#"
                  v-tooltip="
                    $t(
                      'school.academic.setup.program.subject.core_subjects.delete'
                    )
                  "
                  class="text-danger"
                  @click.prevent="destroy(record)"
                  :disabled="record._deleting"
                >
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </td>
            </template>
          </ts-table>
        </div>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData">
          </ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import ShowComponent from './show-component.vue'

export default {
  name: 'subject-core',
  props: ['subjects'],
  data () {
    return {
      loading: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('subjectCore', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.subjectCore.search
      },
      set (newValue) {
        this.$store.commit('subjectCore/SET_SEARCH', newValue)
        this.$store.commit('subjectCore/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.subject_(en)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.subject_(kh)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.ministrySubject_(en)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.ministrySubject_(kh)'
          )
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.total_hour'
          ),
          style: 'text-align:center; width: 5%'
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.credit_theory'
          ),
          style: 'text-align:center; width: 5%'
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.credit_practice'
          ),
          style: 'text-align:center; width: 5%'
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.credit_intern'
          ),
          style: 'text-align:center; width: 5%'
        },
        {
          name: this.$t(
            'school.academic.setup.program.subject.core_subjects.actions'
          ),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('subjectCore/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.showForm(record)
    },
    async destroy (record) {
      if (
        await this.$confirmModal.danger(
          this.$t(
            'school.academic.setup.program.subject.core_subjects.are_you_sure_to_delete'
          )
        )
      ) {
        record._deleting = true
        this.$store
          .dispatch('subjectCore/destroy', record.subject_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm (editData) {
      this.$modal.show(
        FormComponent,
        {
          subjects: this.subjects,
          editData: editData
        },
        {
          height: 'auto',
          scrollable: true,
          clickToClose: false
        }
      )
    },
    showComponent (item) {
      this.$modal.show(
        ShowComponent,
        {
          data: item
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'subject-core-create') {
      this.$store.commit('subjectCore/RESET_STATE')
    }
    next()
  }
}
</script>
